import { IAM_PROVIDER, TENANT_ID } from 'global/constants';

import { getTenantId } from './tenantUtil';

const getRuntimeProvider = () =>
  typeof window !== 'undefined' ? window.__EFIX_RUNTIME_CONFIG__?.IAM_PROVIDER : undefined;

/**
 * Spelled out literally, not computed: webpack's DefinePlugin only inlines `process.env.REACT_APP_*`
 * when accessed as a literal member expression - a computed lookup resolves to undefined in prod.
 */
const OKTA_CLIENT_ID_BY_TENANT = {
  [TENANT_ID.EDI]: process.env.REACT_APP_OKTA_CLIENT_ID_EDI,
  [TENANT_ID.SHNG]: process.env.REACT_APP_OKTA_CLIENT_ID_SHNG,
  [TENANT_ID.AVA]: process.env.REACT_APP_OKTA_CLIENT_ID_AVA,
  [TENANT_ID.BAG]: process.env.REACT_APP_OKTA_CLIENT_ID_BAG,
  [TENANT_ID.LVN]: process.env.REACT_APP_OKTA_CLIENT_ID_LVN,
  [TENANT_ID.MTN]: process.env.REACT_APP_OKTA_CLIENT_ID_MTN,
};

/**
 * Which CIAM provider the frontend talks to. Defaults to Salesforce; must stay in sync with
 * the backend's EFIX_API_IAM_PROVIDER.
 * @return {string} one of IAM_PROVIDER
 */
export const getIamProvider = () => {
  const provider = (getRuntimeProvider() || process.env.REACT_APP_IAM_PROVIDER || '')
    .trim()
    .toLowerCase();
  return provider === IAM_PROVIDER.OKTA ? IAM_PROVIDER.OKTA : IAM_PROVIDER.SALESFORCE;
};

export const isOktaProvider = () => getIamProvider() === IAM_PROVIDER.OKTA;

/**
 * Auth0 login domain. Throws if unset - beats silently building a broken `https:///authorize`.
 * @return {string} host name without protocol
 */
export const getOktaDomain = () => {
  const domain = (process.env.REACT_APP_OKTA_DOMAIN || '').trim();
  if (!domain) {
    throw new Error('REACT_APP_OKTA_DOMAIN is not configured');
  }
  return domain;
};

/**
 * @param {string} [tenantId] - defaults to the currently resolved tenant
 * @return {string} the Auth0 client id of that tenant, or an empty string when not configured
 */
export const getOktaClientId = (tenantId) => {
  const tenant = tenantId || getTenantId();
  return (OKTA_CLIENT_ID_BY_TENANT[tenant] || '').trim();
};
